import { Link } from "react-router-dom";

export const LEGAL_LINE = "LS ASSUR – ORIAS n° 26005663 – RCS Paris 993 855 527";

export const LegalBottom = ({ dark = true }) => (
  <div className={`space-y-2 ${dark ? "text-white/50" : "text-gray-500"}`} data-testid="legal-bottom">
    <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
      <Link to="/mentions-legales" className={dark ? "hover:text-white" : "hover:text-[#102692]"} data-testid="footer-mentions-link">Mentions légales</Link>
      <Link to="/politique-de-confidentialite" className={dark ? "hover:text-white" : "hover:text-[#102692]"} data-testid="footer-privacy-link">Politique de confidentialité</Link>
      <button onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))} className={dark ? "hover:text-white" : "hover:text-[#102692]"} data-testid="footer-cookies-link">Gestion des cookies</button>
    </div>
    <p data-testid="footer-legal-line">{LEGAL_LINE}</p>
    <p>© 2026 Jyvis Assurances. Tous droits réservés.</p>
  </div>
);

export const SimpleLegalFooter = () => (
  <footer className="border-t border-gray-100 py-6 text-center text-xs mt-10" data-testid="simple-legal-footer">
    <LegalBottom dark={false} />
  </footer>
);
